import { _ as _baseGetAllKeys } from './_baseGetAllKeys.mjs';
import { _ as _getSymbolsIn } from './_getSymbolsIn.mjs';
import { k as keysIn_1 } from './keysIn.mjs';

var baseGetAllKeys = _baseGetAllKeys,
    getSymbolsIn = _getSymbolsIn,
    keysIn = keysIn_1;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn;

export { _getAllKeysIn as _ };
